/**
 * @author 3173
 * @description 远程认证详情页面配置
 * @Date  2020/8/15
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool, utils_tool } from '@/tool';
import { WizPhoneCall, WizCallLog } from '@/containers/common';
import { getLocationOrgin } from "@/utils/commonUtils";
let { WizContainer, WizReduxTemplate, WizInputNumber, modelUtils } = framework_tool;
let { WizBrowserExport, WizModal } = component_tool;
let { Session, Storage } = utils_tool;

class TeacherRemoteAuthDetailList extends WizContainer {
  componentName = 'teacherRemoteAuthDetailList';
  constructor(props) {
    super(props);
    let user = storage.getStorage("user");
    this.avatar = user.avatar
    this.state = {
      callModalShow: false,
      locCallRecord: {},
      callLogShow: false,
      selectedRecord: {},
      hktDefaultAvatar : user.avatar && user.avatar!="" ? user.avatar : null
    }
    this.keyforms = (new Date().getTime());

  }

  componentDidMount() {
    if((!this.avatar) || this.avatar=="" ){
      this.doAction({
        path: "commonConfig/queryByKey",
        payload: {
          key: "queryByKey",
          apiParams: {key: 'hktDefaultAvatar'},
        }
      });
    }
  }

  _queryByKeyHandler(nextProps, nextState) {
    let {queryByKey} = nextProps
    if (queryByKey['success'] && queryByKey['data']) {
      nextState.hktDefaultAvatar = queryByKey['data']
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _exportStudentAchievement(nextProps, nextState, key) {
    let o = nextProps[key]
    let excelColumns = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '55px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' }
        }
      },
      {
        headerName: '学员账号',
        field: 'userName',
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' }
        }
      },
      {
        headerName: '经销商简称',
        field: 'dealerName',
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' }
        }
      },
      {
        headerName: '经销商代码',
        field: 'dealerCode',
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' }
        }
      },
      {
        headerName: '考卷名称',
        field: 'examPaperName',
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' }
        }
      },
      {
        headerName: '模块名称',
        field: 'moduleName',
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' }
        }
      },
      {
        headerName: '模块用时（单位：秒）',
        field: 'timeConsuming',
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' }
        }
      },
      {
        headerName: '模块得分',
        field: 'moduleScore',
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' }
        }
      },
      {
        headerName: '总分',
        field: 'score',
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
          // numFmt: '0.00',
        },
      }
    ];
    if (o['success']) {
      const _data = { ...o.data }
      const studentModule = _data.studentModule
      let dataList = []
      delete _data.studentModule
      if (studentModule.length) {
        dataList = studentModule.map(val => {
          return {
            moduleName: val.moduleName,
            timeConsuming: val.timeConsuming,
            moduleScore: val.score,
            ..._data
          }
        })
      } else {
        dataList = [_data]
      }
      const n = (studentModule ? studentModule.length : 0) + 2;
      const _name = `学员成绩-${_data.fullName}`
      let exportObj = {
        title: _name,
        sheetName: _name,
        columns: excelColumns.filter((_, index) => index),
        rows: dataList,
        filename: `${_name}.xlsx`
      }
      if (studentModule.length) {
        exportObj = { ...exportObj, rowMergeCell: [`A3:A${n}`, `B3:B${n}`, `C3:C${n}`, `D3:D${n}`, `E3:E${n}`, `I3:I${n}`] }
      }
      WizBrowserExport(exportObj)
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
          font: {}
        },
      },
      {
        headerName: '学员账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },

      {
        headerName: '经销商简称',
        field: 'dealerName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '经销商代码',
        field: 'dealerCode',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '认证日期',
        field: 'authDateStr',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '认证时间',
        field: 'startToEndDateStr',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        },
      },
      {
        headerName: "认证场次",
        field: "name",
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: "认证名称",
        field: "remoteAuthName",
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '讲师',
        field: 'lectureName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '总得分',
        field: 'score',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '通过状态',
        field: 'pass',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '发布状态',
        field: 'publishStateName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '认证状态',
        field: 'authStateName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        let publishStateName = '';
        switch (d.publishState) {
          case 0:
            publishStateName = "待更新";
            break;
          case 1:
            publishStateName = "可发布";
            break;
          case 2:
            publishStateName = "已发布";
            break;
          case 3:
            publishStateName = "未参考";
            break;
        }
        let authStateName = '';
        switch (d.authState) {
          case 0:
            authStateName = "未开始";
            break;
          case 1:
            authStateName = "已开始";
            break;
          case 2:
            authStateName = "认证中";
            break;
          case 3:
            authStateName = "未参考";
            break;
          case 4:
            authStateName = "已完成";
            break;
          case 5:
            authStateName = "可回看";
          case 6:
            authStateName = "已作废";
            break;
        }
        if (_d.pass === 0) {
          _d.pass = '未通过'
        } else if (_d.pass === 1) {
          _d.pass = '通过'
        } else {
          _d.pass = ""
        }
        _d.publishStateName = publishStateName;
        _d.authStateName = authStateName;
        if ((!_d.score && _d.score != 0) || _d.score < 0) {
          _d.score = "";
        }
        _data.push(_d)
      });


      WizBrowserExport({
        title: '认证详情信息',
        sheetName: '认证详情信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '认证详情信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleQUERY(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      this.keyforms = (new Date().getTime());
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  /**
    * 拨打电话
  */
  openCall = (record) => {
    this.setState({ callModalShow: true, locCallRecord: record })
  }
  //通话记录
  openCallLog = (record) => {
    let value = JSON.parse(sessionStorage.getItem('searchMap'));
    let filterSearch = value.filter(item => item.key !== '#/remoteAuth/teacherRemoteAuthDetailList')
    sessionStorage.setItem('searchMap', JSON.stringify(filterSearch))
    this.setState({ callLogShow: true, locCallRecord: record ? record : {} })
  }

  propsAndStateOnChange = {
    checkStudentRemoteAuthDateRe: this._checkStudentRemoteAuthDateReOver.bind(this),
    queryByKey: this._queryByKeyHandler.bind(this),
  }

  _checkStudentRemoteAuthDateReOver(nextProps, nextState) {
    let { checkStudentRemoteAuthDateRe } = nextProps
    if (checkStudentRemoteAuthDateRe['success']) {
      // console.log("selectedRecord==", nextState.selectedRecord)
      // console.log("给我进==")
      let recordInfo = nextState.selectedRecord
      let avatar = nextState.hktDefaultAvatar
      const { id, personId, remoteAuthId, authState, fullName ,userEmail,lectureName,userPassword,meetingNo} = recordInfo
      let token = Storage.getStorage('token');
      let hktClassroomInfo = {id, personId, remoteAuthId, authState, fullName ,userEmail,lectureName,userPassword,meetingNo,avatar}
      Session.set('hktClassroomInfo',hktClassroomInfo);
     // let queryString = `id=${id}&personId=${personId}&remoteAuthId=${remoteAuthId}&authState=${authState}&fullName=${fullName}&tk=${token}&userEmail=${userEmail}&lectureName=${lectureName}&userPassword=${atob(userPassword)}&meetingNo=${meetingNo}`
      let url = getLocationOrgin() + `/#/smartClassroomRemote/room`
      window.open(url, '_blank');
      //进入课堂
      return true;
    } else {
      wizNotice.error(checkStudentRemoteAuthDateRe['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _render() {
    const { callModalShow, locCallRecord, callLogShow } = this.state;
    let keyforms = this.keyforms;
    let user = Storage.getStorage('user') || {}
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this),
      apiDataFormat: {
        list: this._handleQUERY,
        publishState: this._handleCMD,
        export: this._handleFile,
        exportStudentAchievement: this._exportStudentAchievement,
      },
      user
    })
    return <>
      <WizReduxTemplate {..._reduxTemplateCofig} />
      {callModalShow ? <WizPhoneCall entityType={8} modalShow={callModalShow} record={locCallRecord}
        closeModal={() => this.setState({ callModalShow: false })} /> : null}
      <WizModal title='通话记录' destroyOnClose={true} visible={callLogShow} footer={null} onCancel={() => this.setState({ callLogShow: false })} width={850}>
        <WizCallLog entityType={8} entityId={locCallRecord.id} />
      </WizModal>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentRemoteAuthDetail ,commonConfig} = state;
  const checkStudentRemoteAuthDateRe = modelUtils.getModelEntity(studentRemoteAuthDetail, 'studentRemoteAuthDetail@checkStudentRemoteAuthDate');
  const queryByKey = modelUtils.getModelEntity(commonConfig, 'queryByKey');
  const load = modelUtils.getLoadingState(state, ['studentRemoteAuthDetail']);
  return {
    checkStudentRemoteAuthDateRe,
    queryByKey,
    ...load
  };
};

export default connect(mapStateToProps)(TeacherRemoteAuthDetailList);
